import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/Services/User/user.service';
import { ToastService } from 'src/app/Services/toast/toast.service';

@Component({
  selector: 'app-otp-pattern',
  templateUrl: './otp-pattern.component.html',
  styleUrls: ['./otp-pattern.component.scss']
})
export class OtpPatternComponent implements OnInit {
  form_group!: FormGroup;
  submitted = false;
  disabled = '';
  otp: any;

  constructor(
    private formBuilder:FormBuilder,
    private router:Router, 
    private userservice:UserService,
    private toast : ToastService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form_group = this.formBuilder.group({
      otp1: ['', [Validators.required]],
      otp2: ['', [Validators.required]],
      otp3: ['', [Validators.required]],
      otp4: ['', [Validators.required]],
      otp5: ['', [Validators.required]],
      otp6: ['', [Validators.required]],
    });
  }

  get f() {
    return this.form_group.controls;
  }
  verifyOTP(): void {
  
    const otp = this.concatOTP();
    const email = localStorage.getItem('email') || '';

    this.userservice.verifyOTP(email, otp).subscribe(
      (data) => {
        localStorage.setItem('otp', otp);
        // OTP verification successful, navigate to new password component
        this.router.navigate(['/newPassword']);
        
      },
      (error) => {
        // Handle error
        console.error(error);
        this.toast.ErrorToast('Invalid or expired OTP. Please try again.');
      }
    );
  }
  resendOTP(): void {
    const email = localStorage.getItem('email') || '';

    this.userservice.generateOTP(email).subscribe(
      (data) => {
        // OTP sent successfully
        this.toast.SuccessToast('OTP resent successfully.');
      },
      (error) => {
        // Handle error
        console.error(error);
        this.toast.ErrorToast('Failed to resend OTP. Please try again.');
      }
    );
  }

  concatOTP() {
    return (
      this.form_group.value.otp1 +
      this.form_group.value.otp2 +
      this.form_group.value.otp3 +
      this.form_group.value.otp4 +
      this.form_group.value.otp5+
      this.form_group.value.otp6
    );
  }

}
